export default __webpack_public_path__ + "static/media/template_pro__0005_22---AndrewRobl.01b0ee9a.png";